//*****************************************************************************
// Remove p tags from images and/or iframes
//*****************************************************************************

jQuery(document).ready(function($) {
    // Unwrap images
    //$('p img').unwrap();
    $('p > img').unwrap();

     // Unwrap images and iframes
    //$('p img, p .fluid-width-video-wrapper').unwrap();

});




// Animation On Scroll Global Settings
// https://github.com/michalsnik/aos
AOS.init({
	startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
	mirror: true, // whether elements should animate out while scrolling past them
	//offset: 100,
	//duration: 600,
	//easing: 'ease-in-sine',
	//delay: 300,

});





// Using Jquery To Add A Dynamic “Back To Top” Floating Button With Smooth Scroll
jQuery(document).ready(function() {
    var offset = 220;
    var duration = 500;
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > offset) {
            jQuery('.back-to-top').fadeIn(duration);
        } else {
            jQuery('.back-to-top').fadeOut(duration);
        }
    });

    jQuery('.back-to-top').click(function(event) {
        event.preventDefault();
        jQuery('html, body').animate({scrollTop: 0}, duration);
        return false;
    })
});


